/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{-webkit-box-flex:1;flex:1;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}[_nghost-%COMP%]   lp2-cookie-notice[_ngcontent-%COMP%]{position:fixed;bottom:0;left:0;width:100%}[_nghost-%COMP%]   .spreader[_ngcontent-%COMP%]{-webkit-box-flex:1;flex:1}"];
export { styles as styles };
//# sourceMappingURL=login-page.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/login/login-page/login-page.component.scss.shim.ngstyle.js
// module id = 1561
// module chunks = 26 27 28